<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="39" height="34" viewBox="0 0 39 34">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <path
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M34.667 25.374c0 1.373-1.12 2.485-2.5 2.485H30.5c1.38 0 2.5 1.113 2.5 2.484C33 31.717 31.88 32 30.5 32H19.667c-4.752 0-6.247-.828-12.08-1.657v-14.08c4.083 0 11.246-7.455 11.246-14.081 0-2.62 3.647-3.595 5 1.19.834 2.951-1.666 8.75-1.666 8.75H35.5c1.38 0 2.5 1.112 2.5 2.484 0 1.373-1.12 3.313-2.5 3.313h-1.667c1.38 0 2.5 1.113 2.5 2.485 0 1.373-1.12 2.485-2.5 2.485h-1.666c1.38 0 2.5 1.113 2.5 2.485z"
        transform="translate(0 1)"
      />
      <path :stroke="color" d="M.5 32.5v-19h7v19h-7z" transform="translate(0 1)" />
      <path
        :fill="color"
        d="M5 29c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1"
        transform="translate(0 1)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
